import CustomText from "@components/CustomText";
import React from "react";
import { StyleSheet, TouchableNativeFeedback, View } from "react-native";
import { colors } from "@constants/theme";

const MarkDeliveryOrReturnBtn = ({
  handleNavigation,
  fromDeliverToCxBtn,
  btn_txt = "",
  disabled = false,
}) => {
  return (
    <TouchableNativeFeedback
      testID="MarkDeliveryOrReturnBtn"
      onPress={handleNavigation}
      disabled={disabled}
    >
      <View
        style={[
          styles.container,
          {
            backgroundColor: fromDeliverToCxBtn
              ? colors.plain_green
              : colors.primary,
            opacity: disabled ? 0.8 : 1,
          },
        ]}
      >
        <CustomText variant="title_18" style={{ color: "white" }}>
          {btn_txt}
        </CustomText>
      </View>
    </TouchableNativeFeedback>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: "rgba(0, 171, 89, 1)",
    paddingVertical: 10,
    alignItems: "center",
    borderRadius: 8,
  },
});

export default MarkDeliveryOrReturnBtn;
